//import { PidController } from "../../../../../web-graphics";
//import { MeanPidCalculator } from "../../../../../web-graphics";
//import { MeanCalculator } from "../../../../../web-graphics";

//var abs = Math.abs;

export class HistogramSignalBuffer {
  constructor(settings) {
    this.settings = settings;
    this.onIsolineChangeAction = null;
    HistogramSignalBuffer._createBuffers(this);
  }

  // scaleX in mm/s
  setScaleX(newScaleX) {
    this.settings.scaleX = newScaleX;
    this.recreateBuffers();
  }

  setScaleY(newScaleY) {
    this.settings.scaleY = newScaleY;
    //this.updatePixelsPointsValues();
    this.recreateBuffers();
  }

  // plotSize: { width: 0, height: 0}, windowSize: { width: 0, height: 0 }
  updateWindowSize(plotSize, windowSize) {
    this.settings.plotSize = plotSize;
    this.settings.windowSize = windowSize;
    this.recreateBuffers();
  }

  reset() {
    this.recreateBuffers();
  }

  setFilters(filters) {
    this.settings.filters = filters;
    //this.updatePointsValues();
  }

  // data in UserUnits
  applyFilters(data) {
    let filteredData = data;
    for (let i = 0; i < this.filters.length; i++) {
      filteredData = this.filters[i].filter.exe(filteredData);
    }
    return filteredData;
  }

  addData(data) {
    this._addRectToBuffer(data);
  }

  addDataArray(dataArray) {
    for (let dataIndex = 0; dataIndex < dataArray.length; dataIndex++) {
      this._addRectToBuffer(dataArray[dataIndex]);
    }
  }

  recreateBuffers() {
    HistogramSignalBuffer._createBuffers(this);
  }

  getLastValidColumnIndex() {
    return this.columnCount == 0 ? undefined : this.columnCount - 1;
  }

  getLastValidPointX() {
    if (this.columnCount == 0) {
      return undefined;
    }
    const lastColumn = this.columns[this.columnCount - 1];
    return lastColumn?.x + lastColumn?.width;
  }

  getDataByIndex(columnIndex) {
    if (columnIndex < 0 || columnIndex >= this.columnCount) {
      return undefined;
    }
    return this.columns[columnIndex].value;
  }

  getData(x) {
    const columnIndex = this.getColumnIndex(x);
    if (columnIndex === undefined) {
      return undefined;
    }
    return this.columns[columnIndex].value;
  }

  getColumnIndex(x) {
    return this._searchColumnIndex(x, 0, this.columnCount - 1);
  }

  static _createBuffers(bufferObject) {
    const plotWidth = bufferObject.settings.plotSize.width;
    let vertexBufferData = [];
    vertexBufferData.length = plotWidth * 8;
    vertexBufferData.fill(0);

    let indexBufferData = [];
    indexBufferData.length = plotWidth * 6;
    indexBufferData.fill(0);

    bufferObject.columns = [];
    bufferObject.columns.length = plotWidth;
    bufferObject.columns.fill({});
    bufferObject.vertexBuffer = new Float32Array(vertexBufferData);
    bufferObject.indexBuffer = new Uint16Array(indexBufferData);
    bufferObject.currColumnIndex = 0;
    bufferObject.currX = 0;
    bufferObject.isFullWidth = false;
    bufferObject.columnCount = 0;
  }

  _addRectToBuffer(data) {
    if (this.isFullWidth) {
      if (this.currX + data.width > this.settings.plotSize.width) {
        this._setDataToFullBuffer({
          width: this.settings.plotSize.width - this.currX,
          value: data.value
        });
        this.currColumnIndex++;
        this.currColumnIndex %= this.columnCount;
        let width = data.width + this.currX - this.settings.plotSize.width;
        this.currX = 0;
        this._setDataToFullBuffer({
          width: width,
          value: data.value
        });
        this.currX += width;
      } else {
        this._setDataToFullBuffer(data);
        this.currX += data.width;
      }
      this.currColumnIndex++;
      this.currColumnIndex %= this.columnCount;
    } else {
      this.isFullWidth = this.currX + data.width >= this.settings.plotSize.width;
      if (this.isFullWidth) {
        let width = this.settings.plotSize.width - this.currX;
        this._setDataToNotFullBuffer({
          width: width,
          value: data.value
        });
        this.currColumnIndex++;
        this.currColumnIndex %= this.columnCount;
        width = data.width + this.currX - this.settings.plotSize.width;
        this.currX = 0;
        if (width > 0) {
          this._setDataToFullBuffer({
            width: width,
            value: data.value
          });
          this.currX += width;
        }
      } else {
        this._setDataToNotFullBuffer(data);
        this.currX += data.width;
      }
      this.currColumnIndex++;
    }
  }

  _updateBuffers(beginColumnIndex, endColumnIndex) {
    for (let columnIndex = beginColumnIndex; columnIndex <= endColumnIndex; columnIndex++) {
      this._setRectDataToBuffers(
        columnIndex,
        this.columns[columnIndex]?.x,
        this.columns[columnIndex]?.width,
        this.columns[columnIndex]?.value
      );
    }
  }

  _setRectDataToBuffers(columnIndex, x, width, value) {
    this._setRectToVertexBuffer(columnIndex, x, 0, width, value * this.settings.scaleY);
    this._setRectToIndexBuffer(columnIndex);
  }

  _setRectToVertexBuffer(columnIndex, x, y, width, height) {
    const calcX = /*this.absoluteLocation.x +*/ x;
    const calcY = /*this.absoluteLocation.y +*/ y;
    const calcWidth = width == 0 ? 1 : width;
    const calcHeight = height == 0 ? 1 : height;
    const startVertexIndex = columnIndex * 8;

    this.vertexBuffer[startVertexIndex] = calcX;
    this.vertexBuffer[startVertexIndex + 1] = calcY + calcHeight;
    this.vertexBuffer[startVertexIndex + 2] = calcX;
    this.vertexBuffer[startVertexIndex + 3] = calcY;
    this.vertexBuffer[startVertexIndex + 4] = calcX + calcWidth;
    this.vertexBuffer[startVertexIndex + 5] = calcY;
    this.vertexBuffer[startVertexIndex + 6] = calcX + calcWidth;
    this.vertexBuffer[startVertexIndex + 7] = calcY + calcHeight;
  }

  _setRectToIndexBuffer(columnIndex) {
    const bufferIndex = columnIndex * 6;
    const rectIndex = columnIndex * 4;

    this.indexBuffer[bufferIndex] = rectIndex + 3;
    this.indexBuffer[bufferIndex + 1] = rectIndex + 2;
    this.indexBuffer[bufferIndex + 2] = rectIndex + 1;
    this.indexBuffer[bufferIndex + 3] = rectIndex + 3;
    this.indexBuffer[bufferIndex + 4] = rectIndex + 1;
    this.indexBuffer[bufferIndex + 5] = rectIndex;
  }

  // this.currX + data.width <= this.settings.plotSize.width
  _setDataToFullBuffer(data) {
    let replaceLastIndex = this.currColumnIndex;
    // find last insert column
    let x = this.currX;
    do {
      x += this.columns[replaceLastIndex]?.width;
      if (x < data?.width) {
        replaceLastIndex++;
      }
    } while (x < data.width);
    let replacedColumnsWidth = x - this.currX;
    if (replacedColumnsWidth == data.width) {
      if (this.currColumnIndex == replaceLastIndex) {
        this.columns[this.currColumnIndex] = {
          x: this.currX,
          value: data.value,
          width: data.width
        };
        this._updateBuffers(this.currColumnIndex, this.currColumnIndex);
      } else {
        this.columns[this.currColumnIndex] = {
          x: this.currX,
          value: data.value,
          width: data.width
        };
        let removedColumnCount = replaceLastIndex - this.currColumnIndex;
        let insertIndex = this.currColumnIndex + 1;
        for (let columnIndex = replaceLastIndex + 1; columnIndex < this.columnCount; columnIndex++) {
          this.columns[insertIndex] = this._createColumnCopy(this.columns[columnIndex]);
          insertIndex++;
        }
        this.columnCount -= removedColumnCount;
        this._updateBuffers(this.currColumnIndex, this.columnCount - 1);
      }
    } else {
      if (this.currColumnIndex == replaceLastIndex) {
        if (this.currColumnIndex == this.columnCount - 1) {
          this.columns[this.currColumnIndex] = {
            x: this.currX,
            value: data.value,
            width: data.width
          };
          this._updateBuffers(this.currColumnIndex, this.currColumnIndex);
        } else {
          for (let columnIndex = this.columnCount - 1; columnIndex > this.currColumnIndex; columnIndex--) {
            this.columns[columnIndex + 1] = this.createColumnCopy && this.createColumnCopy(this.columns[columnIndex]);
          }
          this.columns[this.currColumnIndex + 1] = {
            x: this.currX + data.width,
            value: this.columns[this.currColumnIndex].value,
            width: replacedColumnsWidth - data.width
          };
          this.columns[this.currColumnIndex] = {
            x: this.currX,
            value: data.value,
            width: data.width
          };
          this.columnCount++;
          this._updateBuffers(this.currColumnIndex, this.columnCount - 1);
        }
      } else {
        this.columns[this.currColumnIndex + 1] = {
          x: this.currX + data.width,
          value: this.columns[this.currColumnIndex].value,
          width: replacedColumnsWidth - data.width
        };
        this.columns[this.currColumnIndex] = {
          x: this.currX,
          value: data.value,
          width: data.width
        };
        let insertIndex = this.currColumnIndex + 2;
        for (let columnIndex = replaceLastIndex + 1; columnIndex < this.columnCount; columnIndex++) {
          this.columns[insertIndex] = this._createColumnCopy(this.columns[columnIndex]);
          insertIndex++;
        }
        let removedColumnCount = replaceLastIndex - this.currColumnIndex - 1;
        this.columnCount -= removedColumnCount;
        this._updateBuffers(this.currColumnIndex, this.columnCount - 1);
      }
    }
  }

  _setDataToNotFullBuffer(data) {
    this.columns[this.currColumnIndex] = {
      x: this.currX,
      value: data.value,
      width: data.width
    };
    this.columnCount++;
    this._setRectDataToBuffers(this.currColumnIndex, this.currX, data?.width, data?.value);
  }

  _createColumnCopy(columnInfo) {
    return {
      x: columnInfo?.x,
      width: columnInfo?.width,
      value: columnInfo?.value
    };
  }

  _searchColumnIndex(x, low, high) {
    while (low != high) {
      let mid = Math.floor((low + high) / 2);
      if (x >= this.columns[mid].x && x <= this.columns[mid].x + this.columns[mid].width) return mid;
      else if (x > this.columns[mid].x + this.columns[mid].width) low = mid + 1;
      else high = mid - 1;
    }
    if (low == high && (this.columns[low].x > x || this.columns[low].x + this.columns[low].width < x)) {
      return undefined;
    }
    return low;
  }
}
